import { createSlice } from "@reduxjs/toolkit";
import {
  getChannelsBeforeLogin,
  getFilterProducts,
  getPricePredictionOfProducts,
  getSingleProductDetails,
  getSingleProductDetailsBeforeLogin,
  saveUserDetails,
} from "../../../thunks/common-thunks/commonThunk";
import {
  getNearByProducts,
  getNearByProductsBeforeLogin,
  getProductsBeforeLogin,
  productExpiryNotify,
} from "../../../thunks/buyer-thunks/BuyerThunks";
import {
  getAllBulkProducts,
  getAllSellers,
  getChannelsFromProductType,
  getProductDetails,
  getProductsPerUser,
  getProductTypeList,
  postTransferProducts,
  saveClonedProductDetails,
  saveProductDetails,
  searchProductsByIdAndName,
} from "../../../thunks/seller-thunks/SellerThunk";
import { message } from "antd";

const initialState = {
  status: "idle", // "idle" | "loading" | "success" | "failed"
  isLoading: false,
  error: null,
  productsList: [],
  productsPerUser: [],
  nearByProductsList: [],
  productTypeList: [],
  productChannelsList: [],
  savedProductStatus: null,
  savedClonedProductStatus: null,
  nearByProductsListBefore: [],
  product: null,
  filterProducts: null,
  channelData: null,
  locationList: null,
  minPrice: null,
  maxPrice: null,
  minDate: null,
  maxDate: null,
  singleProduct: null,
  sizeList: [],
};

export const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    RESET_PRODUCT_CHANNELS: (state) => {
      state.productChannelsList = [];
    },
    RESET_PRODUCT: (state) => {
      state.product = null;
    },
    RESET_SINGLE_PRODUCT: (state) => {
      state.singleProduct = null;
    },
    RESET_STATUS: (state) => {
      state.status = "idle";
      state.product = null;
    },
    RESET_PRODUCTS: (state) => {
      state.searchedProducts = null;
    },
    RESET_FILTER_PRODUCTS: (state) => {
      state.productsList = null;
    },
  },
  extraReducers: (builder) => {
    // getProductsBeforeLogin
    builder
      .addCase(getProductsBeforeLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getProductsBeforeLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.productsList = action.payload;
      })
      .addCase(getProductsBeforeLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // getNearByProducts
    builder
      .addCase(getNearByProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getNearByProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.nearByProductsList = action.payload;
      })
      .addCase(getNearByProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // getProductTypeList
    builder
      .addCase(getProductTypeList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getProductTypeList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.productTypeList = action.payload;
      })
      .addCase(getProductTypeList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // getProductChannelsList
    builder
      .addCase(getChannelsFromProductType.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getChannelsFromProductType.fulfilled, (state, action) => {
        state.isLoading = false;
        state.productChannelsList = action.payload;
      })
      .addCase(getChannelsFromProductType.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
    //getProductChannelsList Before login
    builder
      .addCase(getChannelsBeforeLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getChannelsBeforeLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.productChannelsList = action.payload;
      })
      .addCase(getChannelsBeforeLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    //saveProductDetails
    builder
      .addCase(saveProductDetails.pending, (state) => {
        state.isLoading = true;
        state.status = "loading";
        state.error = null;
      })
      .addCase(saveProductDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.savedProductStatus = action.payload;
        message.success(action.payload.message);
      })
      .addCase(saveProductDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.status = "failed";
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    //save cloned Product Details
    builder
      .addCase(saveClonedProductDetails.pending, (state) => {
        state.isLoading = true;
        state.status = "loading";
        state.error = null;
      })
      .addCase(saveClonedProductDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.savedClonedProductStatus = action.payload;
        message.success(action.payload.message);
      })
      .addCase(saveClonedProductDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.status = "failed";
        state.error = action.payload;
        message.error("Something went wrong!");
      });
    // getnearbyproducts before login
    builder
      .addCase(getNearByProductsBeforeLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getNearByProductsBeforeLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.nearByProductsListBefore = action.payload;
      })
      .addCase(getNearByProductsBeforeLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // price prediction of products
    builder
      .addCase(getPricePredictionOfProducts.pending, (state) => {
        state.predictionLoader = true;
        state.error = null;
      })
      .addCase(getPricePredictionOfProducts.fulfilled, (state, action) => {
        state.predictionLoader = false;
        state.prices = action.payload;
      })
      .addCase(getPricePredictionOfProducts.rejected, (state, action) => {
        state.predictionLoader = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // IO save user details
    builder
      .addCase(saveUserDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(saveUserDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.savedUserDetailsResponse = action.payload;
        message.success(action.payload.message);
      })
      .addCase(saveUserDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // get Product details
    builder
      .addCase(getProductDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getProductDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.product = action.payload;
      })
      .addCase(getProductDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // get Products per user
    builder
      .addCase(getProductsPerUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getProductsPerUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.productsPerUser = action.payload;
      })
      .addCase(getProductsPerUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // get single Product details
    builder
      .addCase(getSingleProductDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSingleProductDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.singleProduct = action.payload;
      })
      .addCase(getSingleProductDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // get single Product details before login
    builder
      .addCase(getSingleProductDetailsBeforeLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        getSingleProductDetailsBeforeLogin.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.singleProduct = action.payload;
        }
      )
      .addCase(getSingleProductDetailsBeforeLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // transfer products to get all sellers
    builder
      .addCase(getAllSellers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllSellers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.getAllSellersList = action.payload.sellers_data;
      })
      .addCase(getAllSellers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // transfer products to get all bulk products
    builder
      .addCase(getAllBulkProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllBulkProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allBulkProducts = action.payload;
      })
      .addCase(getAllBulkProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    //post transfer products
    builder
      .addCase(postTransferProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(postTransferProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.transferProductResponse = action.payload;
        if (action?.payload?.status == 1) {
          message.success(action.payload.message);
        } else {
          message.error(action?.payload?.message);
        }
      })
      .addCase(postTransferProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    //search products
    builder
      .addCase(searchProductsByIdAndName.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(searchProductsByIdAndName.fulfilled, (state, action) => {
        state.isLoading = false;
        state.searchedProducts = action.payload;
      })
      .addCase(searchProductsByIdAndName.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    //search products
    builder
      .addCase(getFilterProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFilterProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.filterProducts = action.payload;
        state.channelData = action.payload?.filter_data?.channel_data;
        state.locationList = action.payload?.filter_data?.location_data;
        state.sizeList = action.payload?.filter_data?.sizes;
        state.minPrice = action.payload?.filter_data?.min_price;
        state.maxPrice = action.payload?.filter_data?.max_price;
        state.minDate = action.payload?.filter_data?.min_date;
        state.maxDate = action.payload?.filter_data?.max_date;
      })
      .addCase(getFilterProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    //product expiry notify
    builder
      .addCase(productExpiryNotify.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(productExpiryNotify.fulfilled, (state, action) => {
        state.isLoading = false;
        state.expiryNotifyMessage = action.payload.message;
        if (action.payload?.status == 1) {
          message.success(action.payload.message);
        } else {
          message.error(action.payload.message);
        }
      })
      .addCase(productExpiryNotify.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});
export const {
  RESET_PRODUCT_CHANNELS,
  RESET_PRODUCT,
  RESET_STATUS,
  RESET_PRODUCTS,
  RESET_SINGLE_PRODUCT,
  RESET_FILTER_PRODUCTS,
} = productSlice.actions;
export default productSlice.reducer;
